import React, { Component } from 'react';

class RowButtonMiami extends Component {
	constructor(props) {
		super(props);
		this._buttonRef = null;
	}

	componentDidMount() {
		if (this._buttonRef && typeof this.props.buttonEvent === "function") {
			this._buttonRef.addEventListener("tap", () => this.props.buttonEvent());
		}
	}

	render() {
		return (
			<div onClick={this.props.onClick} style={{ marginTop: '3.9375vh', marginBottom: '2.8125vh', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch' }} >
				<div style={{ fontSize: '2.1875vh', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-bold", color: '#ffffff', width: '84.375vh' }}>
					{this.props.header}
					<br />
					<span style={{ fontSize: '1.2375vh', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' }}>
						{this.props.message}
					</span>
				</div>

				<div style={{ textAlign: 'right', width: '100%' }} >
					<img ref={el => this._buttonRef = el} alt="Story" src={this.props.button} style={{ width: '12.9375vh' }} />
				</div>
			</div>
		)
	}
}

export default RowButtonMiami;


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/RowButtonMiami.js